import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import debounce from '@utils/debounce';
const initWorkflowSlider = (element) => {
    const sliderElement = element.querySelector('.workflow-section__slider');
    if (!sliderElement)
        return;
    // sliderElement.querySelectorAll('img[loading="lazy"]').forEach((img) => {
    //   const preloader = document.createElement('div');
    //   preloader.classList.add('swiper-lazy-preloader');
    //   preloader.classList.add('swiper-lazy-preloader-white');
    //   img.parentNode?.appendChild(preloader);
    // });
    const pagination = (element === null || element === void 0 ? void 0 : element.querySelector('.workflow-section__pagination')) || null;
    let isDesktop = false;
    const options = {
        modules: [Pagination, Autoplay],
        loop: false,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 500,
        autoplay: false,
        pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true,
        },
    };
    const autoplayDelay = element.hasAttribute('data-autoplay')
        ? +(element.getAttribute('data-autoplay') || 0)
        : 0;
    if (autoplayDelay) {
        options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        };
    }
    let swiper;
    const initSlider = () => {
        isDesktop = matchMedia('(min-width: 768px)').matches;
        if (swiper && isDesktop) {
            swiper.destroy();
            delete sliderElement.swiper;
            swiper = null;
        }
        if (!swiper && !isDesktop) {
            swiper = new Swiper(sliderElement, options);
            sliderElement.swiper = swiper;
        }
    };
    window.addEventListener('resize', debounce(initSlider, 300));
    initSlider();
};
document.querySelectorAll('.workflow-section__main').forEach((element) => {
    initWorkflowSlider(element);
});
